(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"]) return;
  try {
    
  (function () {
    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function whenGsapReady(callback) {
      if (typeof gsap !== 'undefined') {
        callback(gsap, typeof Draggable !== 'undefined' ? Draggable : null);
        return;
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (typeof gsap !== 'undefined') {
          clearInterval(timer);
          callback(gsap, typeof Draggable !== 'undefined' ? Draggable : null);
        } else if (attempts > 40) {
          clearInterval(timer);
          callback(null, null);
        }
      }, 50);
    }

    function setLenisStopped(stopped) {
      var lenis = window.GiemmaTheme && window.GiemmaTheme.lenis;
      if (!lenis) return;
      if (stopped) lenis.stop();
      else lenis.start();
    }

    function initNotFound(root) {
      if (!root || root.dataset.notFoundInit === 'true') return;
      root.dataset.notFoundInit = 'true';

      var stage = root.querySelector('[data-404-stage]');
      var digits = Array.prototype.slice.call(root.querySelectorAll('[data-404-digit]'));
      if (!stage || !digits.length) return;

      var dragEnabled = root.getAttribute('data-404-drag') !== 'false';
      var draggables = [];
      var maxZ = digits.length + 2;

      whenGsapReady(function (gsapApi, DraggableApi) {
        if (gsapApi) {
          digits.forEach(function (digit) {
            gsapApi.set(digit, { x: 0, y: 0, force3D: true });
          });
        }

        if (!gsapApi || !dragEnabled || prefersReducedMotion() || !DraggableApi) {
          digits.forEach(function (digit) {
            digit.style.cursor = 'default';
          });
          return;
        }

        if (window.GiemmaTheme && !window.GiemmaTheme._draggableRegistered) {
          gsapApi.registerPlugin(DraggableApi);
          window.GiemmaTheme._draggableRegistered = true;
        }

        function overflowAllowance(item) {
          return {
            x: item.offsetWidth * 0.35,
            y: item.offsetHeight * 0.35,
          };
        }

        function boundsForItem(item) {
          var allow = overflowAllowance(item);
          var stageRect = stage.getBoundingClientRect();
          var itemRect = item.getBoundingClientRect();
          var currentX = gsapApi.getProperty(item, 'x') || 0;
          var currentY = gsapApi.getProperty(item, 'y') || 0;
          var left = itemRect.left - stageRect.left - currentX;
          var top = itemRect.top - stageRect.top - currentY;
          var itemW = item.offsetWidth;
          var itemH = item.offsetHeight;
          var stageW = stage.clientWidth;
          var stageH = stage.clientHeight;

          return {
            minX: -allow.x - left,
            maxX: stageW + allow.x - left - itemW,
            minY: -allow.y - top,
            maxY: stageH + allow.y - top - itemH,
          };
        }

        function refreshBounds() {
          draggables.forEach(function (instance) {
            instance.applyBounds(boundsForItem(instance.target));
          });
        }

        draggables = digits.map(function (digit) {
          return DraggableApi.create(digit, {
            type: 'x,y',
            bounds: boundsForItem(digit),
            edgeResistance: 0.85,
            inertia: false,
            zIndexBoost: false,
            onPress: function () {
              maxZ += 1;
              this.target.style.zIndex = String(maxZ);
              this.target.classList.add('is-dragging');
              setLenisStopped(true);
              gsapApi.killTweensOf(this.target);
            },
            onDragEnd: function () {
              this.target.classList.remove('is-dragging');
              setLenisStopped(false);
            },
            onRelease: function () {
              this.target.classList.remove('is-dragging');
              setLenisStopped(false);
            },
          })[0];
        });

        window.addEventListener('resize', refreshBounds);

        document.addEventListener('shopify:section:unload', function (event) {
          if (!event.target.contains(root) && event.target !== root) return;
          window.removeEventListener('resize', refreshBounds);
          draggables.forEach(function (instance) {
            instance.kill();
          });
        });
      });
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll('.not-found[data-section-id]').forEach(initNotFound);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.not-found[data-section-id]');
      if (section) initNotFound(section);
    });

    document.addEventListener('giemma:page:enter', function (event) {
      initAll(event.detail && event.detail.container);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.customElements.get('cart-drawer')) return;

    function isCartPage() {
      var pathname = (window.location && window.location.pathname) || '/';
      if (pathname.length > 1 && pathname.slice(-1) === '/') {
        pathname = pathname.slice(0, -1);
      }
      return document.body.classList.contains('template-cart') || pathname === '/cart';
    }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setLenisStopped(stopped) {
      var lenis = window.GiemmaTheme && window.GiemmaTheme.lenis;
      if (!lenis) return;
      if (stopped) lenis.stop();
      else lenis.start();
    }

    function whenGsapReady(callback) {
      if (typeof gsap !== 'undefined') {
        callback(gsap);
        return;
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (typeof gsap !== 'undefined') {
          clearInterval(timer);
          callback(gsap);
        } else if (attempts > 40) {
          clearInterval(timer);
          callback(null);
        }
      }, 50);
    }

    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = '(' + count + ')';
      });
    }

    function setProductFormLoading(form, submitter, isLoading, previousState) {
      var buttons = form ? Array.prototype.slice.call(form.querySelectorAll('[type="submit"]')) : [];
      var active = submitter && buttons.indexOf(submitter) !== -1 ? submitter : buttons[0] || null;

      if (isLoading) {
        var state = {
          active: active,
          entries: buttons.map(function (button) {
            return {
              button: button,
              label: button.textContent,
              disabled: button.disabled,
            };
          }),
        };

        state.entries.forEach(function (entry) {
          entry.button.disabled = true;
          entry.button.setAttribute('aria-busy', 'true');
        });

        if (active) {
          var loadingLabel = active.getAttribute('data-loading-label');
          if (!loadingLabel) {
            var root = form.closest('[data-product]');
            if (root) {
              loadingLabel = active.hasAttribute('data-quick-buy')
                ? root.getAttribute('data-buying-label')
                : root.getAttribute('data-adding-label');
            }
          }
          if (loadingLabel) active.textContent = loadingLabel;
        }

        return state;
      }

      var entries = (previousState && previousState.entries) || [];
      entries.forEach(function (entry) {
        entry.button.removeAttribute('aria-busy');
        entry.button.disabled = entry.disabled;
        entry.button.textContent = entry.label;
      });

      return null;
    }

    class CartDrawer extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.overlay = this.querySelector('[data-cart-drawer-overlay]');
        this.panel = this.querySelector('[data-cart-drawer-panel]');
        this.closeButtons = this.querySelectorAll('[data-cart-drawer-close]');
        this.openTimeline = null;
        this.isOpen = false;
        this.sectionId = this.getAttribute('data-section-id');
        this.lastFocus = null;

        this.onKeydown = this.onKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDocumentSubmit = this.onDocumentSubmit.bind(this);
        this.onQtyClick = this.onQtyClick.bind(this);

        this.closeButtons.forEach(
          function (button) {
            button.addEventListener('click', this.close.bind(this));
          }.bind(this),
        );

        if (this.overlay) {
          this.overlay.addEventListener('click', this.close.bind(this));
        }

        this.addEventListener('click', this.onQtyClick);
        this.addEventListener('click', this.onRecAddClick.bind(this));
        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('submit', this.onDocumentSubmit);
        this._onProductSubmitterClick = function (event) {
          var button = event.target.closest('[data-product-form] [type="submit"]');
          if (button) this._lastProductSubmitter = button;
        }.bind(this);
        document.addEventListener('click', this._onProductSubmitterClick, true);

        whenGsapReady(
          function (gsapApi) {
            this.gsap = gsapApi;
            if (gsapApi && this.panel) {
              // On /cart we render the cart layout inside the drawer component,
              // so initialize the panel as visible immediately.
              var initial = isCartPage() ? { xPercent: 0, autoAlpha: 1 } : { xPercent: 100, autoAlpha: 0 };
              gsapApi.set(this.panel, initial);
            }
          }.bind(this),
        );

        window.GiemmaTheme = window.GiemmaTheme || {};
        window.GiemmaTheme.cartDrawer = this;

        // On the /cart page we render a full cart page layout.
        // Keep the component visible via CSS (no auto-open animation).
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('submit', this.onDocumentSubmit);
      }

      lockScroll(lock) {
        document.documentElement.style.overflow = lock ? 'hidden' : '';
        setLenisStopped(lock);
      }

      setOpenState(open) {
        this.isOpen = open;
        this.classList.toggle('is-open', open);
        this.hidden = !open;
        this.setAttribute('aria-hidden', open ? 'false' : 'true');
        this.lockScroll(open);
      }

      getStaggerItems() {
        return this.querySelectorAll('[data-cart-stagger]');
      }

      open() {
        if (isCartPage()) return;
        if (this.isOpen) return;

        this.lastFocus = document.activeElement;
        this.setOpenState(true);
        // On the full /cart page we skip recommendations to match the screenshot
        // and avoid extra network work.
        if (!isCartPage()) {
          this.loadRecommendations();
        }

        var staggerItems = this.getStaggerItems();
        var gsapApi = this.gsap;

        if (!gsapApi || prefersReducedMotion()) {
          if (this.panel) this.panel.style.transform = 'none';
          if (this.overlay) this.overlay.style.opacity = '1';
          staggerItems.forEach(function (item) {
            item.style.opacity = '1';
            item.style.transform = 'none';
          });
          this.focusClose();
          return;
        }

        if (this.openTimeline) this.openTimeline.kill();

        gsapApi.set(this.panel, { xPercent: 100, autoAlpha: 1 });
        if (this.overlay) gsapApi.set(this.overlay, { opacity: 0 });
        gsapApi.set(staggerItems, { autoAlpha: 0, y: 18 });

        this.openTimeline = gsapApi.timeline({
          defaults: { ease: 'power3.out' },
          onComplete: this.focusClose.bind(this),
        });

        if (this.overlay) {
          this.openTimeline.to(this.overlay, { opacity: 1, duration: 0.45 }, 0);
        }

        this.openTimeline.to(this.panel, { xPercent: 0, duration: 0.55 }, 0).to(
          staggerItems,
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.45,
            stagger: 0.06,
            ease: 'power2.out',
          },
          0.18,
        );
      }

      close() {
        if (isCartPage()) return;
        if (!this.isOpen) return;

        var staggerItems = this.getStaggerItems();
        var gsapApi = this.gsap;
        var self = this;

        function finish() {
          self.setOpenState(false);
          if (self.lastFocus && typeof self.lastFocus.focus === 'function') {
            self.lastFocus.focus();
          }
        }

        if (!gsapApi || prefersReducedMotion()) {
          if (this.openTimeline) this.openTimeline.kill();
          if (this.panel) this.panel.style.transform = '';
          if (this.overlay) this.overlay.style.opacity = '';
          staggerItems.forEach(function (item) {
            item.style.opacity = '';
            item.style.transform = '';
          });
          finish();
          return;
        }

        if (this.openTimeline) this.openTimeline.kill();

        this.openTimeline = gsapApi.timeline({
          defaults: { ease: 'power3.inOut' },
          onComplete: finish,
        });

        this.openTimeline.to(
          staggerItems,
          {
            autoAlpha: 0,
            y: 10,
            duration: 0.2,
            stagger: { each: 0.03, from: 'end' },
          },
          0,
        );

        if (this.overlay) {
          this.openTimeline.to(this.overlay, { opacity: 0, duration: 0.35 }, 0);
        }

        this.openTimeline.to(this.panel, { xPercent: 100, duration: 0.4 }, 0.05);
      }

      syncPageMode() {
        if (isCartPage()) {
          this.isOpen = false;
          this.classList.remove('is-open');
          this.hidden = false;
          this.setAttribute('aria-hidden', 'false');
          this.lockScroll(false);
          if (this.gsap && this.panel) {
            this.gsap.set(this.panel, { xPercent: 0, autoAlpha: 1 });
          } else if (this.panel) {
            this.panel.style.transform = 'none';
            this.panel.style.opacity = '1';
            this.panel.style.visibility = 'visible';
          }
          return;
        }

        if (this.isOpen) {
          this.close();
          return;
        }

        this.hidden = true;
        this.setAttribute('aria-hidden', 'true');
        this.classList.remove('is-open');
        this.isOpen = false;
        if (this.gsap && this.panel) {
          this.gsap.set(this.panel, { xPercent: 100, autoAlpha: 0 });
        }
      }

      focusClose() {
        var closeBtn = this.querySelector('[data-cart-drawer-close]');
        if (closeBtn) closeBtn.focus();
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.isOpen) {
          this.close();
        }
      }

      onDocumentClick(event) {
        var trigger = event.target.closest('[data-cart-drawer-open]');
        if (!trigger) return;
        event.preventDefault();
        event.stopPropagation();
        this.open();
      }

      onDocumentSubmit(event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        var submitter = event.submitter;
        // iOS Safari often leaves submitter null; fall back to the focused control.
        if (!submitter && form.matches('[data-product-form]')) {
          var active = document.activeElement;
          if (active && form.contains(active) && active.matches('[type="submit"]')) {
            submitter = active;
          } else if (this._lastProductSubmitter && form.contains(this._lastProductSubmitter)) {
            submitter = this._lastProductSubmitter;
          }
        }

        if (submitter && submitter.getAttribute('name') === 'checkout') return;

        var isProductForm = form.matches('[data-product-form]');
        var action = form.getAttribute('action') || '';
        var isCartAdd = action.indexOf('/cart/add') !== -1;
        if (!isProductForm && !isCartAdd) return;

        if (submitter && submitter.getAttribute('name') === 'return_to') {
          event.preventDefault();

          var redirectUrl =
            submitter.value || submitter.getAttribute('value') || submitter.getAttribute('data-value') || '/checkout';

          var formData = new FormData(form);
          // Prevent accidental inclusion of the redirect parameter in the cart API call.
          try {
            formData.delete('return_to');
          } catch (error) {}

          var loadingState = setProductFormLoading(form, submitter, true);

          fetch(cartRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
          })
            .then(
              function (response) {
                return response.json().then(function (data) {
                  if (!response.ok) throw data;
                  return data;
                });
              }.bind(this),
            )
            .then(function () {
              window.location.href = redirectUrl;
            })
            .catch(function (error) {
              console.error(error);
              setProductFormLoading(form, submitter, false, loadingState);
              form.submit();
            });

          return;
        }

        event.preventDefault();
        this.addFromForm(form, submitter);
      }

      onQtyClick(event) {
        var button = event.target.closest('[data-cart-qty-change]');
        if (!button || !this.contains(button)) return;

        var key = button.getAttribute('data-line-key');
        var quantity = Number(button.getAttribute('data-quantity'));
        if (!key || Number.isNaN(quantity)) return;

        this.changeLine(key, quantity);
      }

      onRecAddClick(event) {
        var button = event.target.closest('[data-cart-rec-add]');
        if (!button || !this.contains(button)) return;

        var variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        button.disabled = true;
        this.addVariant(variantId).finally(function () {
          button.disabled = false;
        });
      }

      loadRecommendations() {
        if (isCartPage()) return;
        var recs = this.querySelector('[data-cart-recs]');
        if (!recs) return;

        var productId = recs.getAttribute('data-product-id');
        var baseUrl = recs.getAttribute('data-recommendations-url');
        var intent = recs.getAttribute('data-intent') || 'related';
        var limit = recs.getAttribute('data-limit') || '2';

        if (!productId || !baseUrl) {
          recs.hidden = true;
          return;
        }

        var url =
          baseUrl +
          '?section_id=' +
          encodeURIComponent(this.sectionId) +
          '&product_id=' +
          encodeURIComponent(productId) +
          '&limit=' +
          encodeURIComponent(limit) +
          '&intent=' +
          encodeURIComponent(intent);

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(
            function (text) {
              var doc = new DOMParser().parseFromString(text, 'text/html');
              var next = doc.querySelector('[data-cart-recs]');
              var current = this.querySelector('[data-cart-recs]');
              if (!next || !current) return;

              var hasProducts = Boolean(next.querySelector('.cart-drawer__recs-grid'));
              var hasApp = Boolean(next.querySelector('.cart-drawer__app'));
              if (!hasProducts && !hasApp) {
                current.hidden = true;
                current.classList.add('cart-drawer__recs--empty');
                return;
              }

              next.hidden = false;
              next.classList.toggle('cart-drawer__recs--empty', !hasProducts);
              current.replaceWith(next);
              if (window.GiemmaTheme && typeof window.GiemmaTheme.enhanceLinkSlide === 'function') {
                window.GiemmaTheme.enhanceLinkSlide(next);
              }
            }.bind(this),
          )
          .catch(function (error) {
            console.error(error);
          });
      }

      fetchSections() {
        return fetch(cartRoot() + '?sections=' + encodeURIComponent(this.sectionId), {
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            return response.json();
          })
          .then(
            function (sections) {
              this.replaceContents(sections[this.sectionId]);
              return fetch(cartRoot() + 'cart.js')
                .then(function (response) {
                  return response.json();
                })
                .then(
                  function (cart) {
                    updateCartCount(cart.item_count || 0);
                    this.loadRecommendations();
                    return cart;
                  }.bind(this),
                );
            }.bind(this),
          );
      }

      replaceContents(html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cart-drawer-contents]');
        var current = this.querySelector('[data-cart-drawer-contents]');
        if (next && current) {
          current.replaceWith(next);
          this.closeButtons = this.querySelectorAll('[data-cart-drawer-close]');
          this.closeButtons.forEach(
            function (button) {
              button.addEventListener('click', this.close.bind(this));
            }.bind(this),
          );
          if (window.GiemmaTheme && typeof window.GiemmaTheme.enhanceLinkSlide === 'function') {
            window.GiemmaTheme.enhanceLinkSlide(next);
          }
          this.loadRecommendations();
        }
      }

      addVariant(variantId) {
        return fetch(cartRoot() + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: this.sectionId,
            sections_url: window.location.pathname,
          }),
        })
          .then(
            function (response) {
              return response.json().then(function (data) {
                if (!response.ok) throw data;
                return data;
              });
            }.bind(this),
          )
          .then(
            function (data) {
              if (data.sections && data.sections[this.sectionId]) {
                this.replaceContents(data.sections[this.sectionId]);
              }
              return fetch(cartRoot() + 'cart.js')
                .then(function (response) {
                  return response.json();
                })
                .then(
                  function (cart) {
                    updateCartCount(cart.item_count || 0);
                    if (!this.isOpen) this.open();
                  }.bind(this),
                );
            }.bind(this),
          )
          .catch(function (error) {
            console.error(error);
          });
      }

      addFromForm(form, submitter) {
        var formData = new FormData(form);
        var loadingState = setProductFormLoading(form, submitter, true);

        fetch(cartRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then(
            function (response) {
              return response.json().then(function (data) {
                if (!response.ok) throw data;
                return data;
              });
            }.bind(this),
          )
          .then(
            function (data) {
              var hasUpdatedSections = data && data.sections && data.sections[this.sectionId];

              if (hasUpdatedSections) {
                this.replaceContents(data.sections[this.sectionId]);
              }

              return fetch(cartRoot() + 'cart.js')
                .then(function (response) {
                  return response.json();
                })
                .then(
                  function (cart) {
                    updateCartCount(cart.item_count || 0);
                    this.open();

                    // If the add response didn't include drawer HTML, refresh it async.
                    if (!hasUpdatedSections) {
                      this.fetchSections().catch(function (error) {
                        console.error(error);
                      });
                    }
                  }.bind(this),
                );
            }.bind(this),
          )
          .catch(function (error) {
            console.error(error);
            form.submit();
          })
          .finally(function () {
            setProductFormLoading(form, submitter, false, loadingState);
          });
      }

      changeLine(key, quantity) {
        fetch(cartRoot() + 'cart/change.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: quantity,
            sections: this.sectionId,
            sections_url: window.location.pathname,
          }),
        })
          .then(
            function (response) {
              return response.json().then(function (data) {
                if (!response.ok) throw data;
                return data;
              });
            }.bind(this),
          )
          .then(
            function (data) {
              if (data.sections && data.sections[this.sectionId]) {
                this.replaceContents(data.sections[this.sectionId]);
              } else {
                return this.fetchSections();
              }
              updateCartCount(data.item_count || 0);
            }.bind(this),
          )
          .catch(function (error) {
            console.error(error);
          });
      }
    }

    customElements.define('cart-drawer', CartDrawer);

    document.addEventListener('giemma:page:enter', function () {
      var drawer = window.GiemmaTheme && window.GiemmaTheme.cartDrawer;
      if (drawer && typeof drawer.syncPageMode === 'function') {
        drawer.syncPageMode();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 0.35;
    var EASE = 'power2.out';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function whenGsapReady(callback) {
      if (typeof gsap !== 'undefined') {
        callback(gsap);
        return;
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (typeof gsap !== 'undefined') {
          clearInterval(timer);
          callback(gsap);
        } else if (attempts > 40) {
          clearInterval(timer);
          callback(null);
        }
      }, 50);
    }

    function setOpenState(item, open) {
      var trigger = item.querySelector('[data-faq-trigger]');
      var panel = item.querySelector('[data-faq-panel]');
      if (!trigger || !panel) return;

      item.classList.toggle('is-open', open);
      if (open) {
        item.setAttribute('data-open', '');
        panel.removeAttribute('hidden');
        panel.removeAttribute('inert');
      } else {
        item.removeAttribute('data-open');
        panel.setAttribute('hidden', '');
        panel.setAttribute('inert', '');
      }
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function animateIcon(gsapApi, icon, open, instant) {
      if (!icon) return;
      if (!gsapApi || prefersReducedMotion() || instant) {
        icon.style.transform = open ? 'rotate(45deg)' : 'rotate(0deg)';
        return;
      }
      gsapApi.to(icon, {
        rotation: open ? 45 : 0,
        duration: DURATION,
        ease: EASE,
        overwrite: 'auto',
      });
    }

    function openPanel(gsapApi, item, instant) {
      var panel = item.querySelector('[data-faq-panel]');
      var icon = item.querySelector('[data-faq-icon]');
      if (!panel) return;

      setOpenState(item, true);
      animateIcon(gsapApi, icon, true, instant);

      if (!gsapApi || prefersReducedMotion() || instant) {
        panel.style.height = 'auto';
        panel.style.overflow = 'visible';
        return;
      }

      gsapApi.killTweensOf(panel);
      gsapApi.set(panel, { height: 0, overflow: 'hidden', autoAlpha: 1 });
      gsapApi.to(panel, {
        height: 'auto',
        duration: DURATION,
        ease: EASE,
        overwrite: 'auto',
        onComplete: function () {
          gsapApi.set(panel, { height: 'auto', overflow: 'visible' });
        },
      });
    }

    function closePanel(gsapApi, item, instant) {
      var panel = item.querySelector('[data-faq-panel]');
      var icon = item.querySelector('[data-faq-icon]');
      if (!panel) return;

      animateIcon(gsapApi, icon, false, instant);

      if (!gsapApi || prefersReducedMotion() || instant) {
        panel.style.height = '';
        setOpenState(item, false);
        return;
      }

      gsapApi.killTweensOf(panel);
      gsapApi.set(panel, { overflow: 'hidden' });
      gsapApi.to(panel, {
        height: 0,
        duration: DURATION,
        ease: EASE,
        overwrite: 'auto',
        onComplete: function () {
          setOpenState(item, false);
          gsapApi.set(panel, { clearProps: 'height,overflow' });
        },
      });
    }

    function initFaq(root) {
      var list = root.querySelector('[data-faq-list]');
      if (!list || list._faqBound) return;
      list._faqBound = true;

      var items = Array.prototype.slice.call(list.querySelectorAll('[data-faq-item]'));
      if (!items.length) return;

      whenGsapReady(function (gsapApi) {
        items.forEach(function (item) {
          var icon = item.querySelector('[data-faq-icon]');
          var isOpen = item.hasAttribute('data-open');
          if (gsapApi) {
            gsapApi.set(icon, { rotation: isOpen ? 45 : 0, transformOrigin: '50% 50%' });
            if (isOpen) {
              gsapApi.set(item.querySelector('[data-faq-panel]'), {
                height: 'auto',
                overflow: 'visible',
              });
            } else {
              gsapApi.set(item.querySelector('[data-faq-panel]'), { height: 0 });
            }
          } else if (icon) {
            icon.style.transform = isOpen ? 'rotate(45deg)' : 'rotate(0deg)';
          }
        });

        list.addEventListener('click', function (event) {
          var trigger = event.target.closest('[data-faq-trigger]');
          if (!trigger || !list.contains(trigger)) return;

          var item = trigger.closest('[data-faq-item]');
          if (!item) return;

          var willOpen = !item.hasAttribute('data-open');

          items.forEach(function (other) {
            if (other === item) return;
            if (other.hasAttribute('data-open')) {
              closePanel(gsapApi, other, false);
            }
          });

          if (willOpen) {
            openPanel(gsapApi, item, false);
          } else {
            closePanel(gsapApi, item, false);
          }
        });
      });
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-faq]').forEach(initFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-faq]');
      if (root) initFaq(root);
    });

    document.addEventListener('giemma:page:enter', function (event) {
      initAll(event.detail && event.detail.container);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncFooterHeight(footer) {
      if (!footer) return;
      var height = footer.getBoundingClientRect().height;
      if (!height) return;
      document.documentElement.style.setProperty('--footer-height', height + 'px');
    }

    function initFooter(footer) {
      syncFooterHeight(footer);

      var mode = footer.getAttribute('data-footer-mode') || 'full';
      if (mode !== 'auto') return;

      var threshold = 64;
      var ticking = false;

      function setState(state) {
        footer.setAttribute('data-state', state);
        requestAnimationFrame(function () {
          syncFooterHeight(footer);
        });
      }

      function updateFromScroll() {
        ticking = false;
        var doc = document.documentElement;
        var scrollBottom = window.scrollY + window.innerHeight;
        var pageHeight = Math.max(doc.scrollHeight, document.body.scrollHeight);
        var nearBottom = scrollBottom >= pageHeight - threshold;
        setState(nearBottom ? 'full' : 'minified');
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateFromScroll);
      }

      updateFromScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    var footers = document.querySelectorAll('[data-footer]');
    footers.forEach(initFooter);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('[data-footer]').forEach(syncFooterHeight);
      }, 100);
    });

    document.addEventListener('giemma:page:enter', function () {
      document.querySelectorAll('[data-footer]').forEach(syncFooterHeight);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const headers = document.querySelectorAll('[data-header]');
    if (!headers.length) return;

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function setLenisStopped(stopped) {
      const lenis = window.GiemmaTheme && window.GiemmaTheme.lenis;
      if (!lenis) return;
      if (stopped) lenis.stop();
      else lenis.start();
    }

    function whenGsapReady(callback) {
      if (typeof gsap !== 'undefined') {
        callback(gsap);
        return;
      }

      let attempts = 0;
      const timer = setInterval(function () {
        attempts += 1;
        if (typeof gsap !== 'undefined') {
          clearInterval(timer);
          callback(gsap);
        } else if (attempts > 40) {
          clearInterval(timer);
          callback(null);
        }
      }, 50);
    }

    function initHeader(header) {
      const toggle = header.querySelector('[data-header-toggle]');
      const drawer = header.querySelector('[data-header-drawer]');
      if (!toggle || !drawer) return;
      if (toggle.dataset.headerBound === 'true') return;
      toggle.dataset.headerBound = 'true';

      const staggerItems = drawer.querySelectorAll('[data-header-stagger]');
      const rootStyles = getComputedStyle(document.documentElement);
      const colorBlack = rootStyles.getPropertyValue('--color-black').trim() || '#151515';
      const colorWhite = rootStyles.getPropertyValue('--color-true-white').trim() || '#ffffff';
      let openTimeline = null;
      let isOpen = false;

      function getClosedInk() {
        const pageStyle = document.querySelector('[data-header-style]');
        if (pageStyle && pageStyle.dataset.headerScheme) {
          return pageStyle.dataset.headerScheme === 'light' ? colorWhite : colorBlack;
        }
        return header.classList.contains('header--light') ? colorWhite : colorBlack;
      }

      function lockScroll(lock) {
        document.documentElement.style.overflow = lock ? 'hidden' : '';
        setLenisStopped(lock);
      }

      function setInk(value) {
        header.style.setProperty('--header-ink', value);
      }

      function clearInkInline() {
        header.style.removeProperty('--header-ink');
      }

      function setOpenState(open) {
        isOpen = open;
        header.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
        drawer.hidden = !open;
        drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        lockScroll(open);
      }

      function openMenu(gsapApi) {
        if (isOpen) return;
        setOpenState(true);

        const inkClosed = getClosedInk();

        if (!gsapApi || prefersReducedMotion()) {
          staggerItems.forEach(function (item) {
            item.style.opacity = '1';
            item.style.transform = 'none';
            item.style.visibility = 'visible';
          });
          drawer.style.transform = 'none';
          drawer.style.opacity = '1';
          drawer.style.visibility = 'visible';
          setInk(colorBlack);
          return;
        }

        if (openTimeline) openTimeline.kill();

        gsapApi.set(drawer, { xPercent: -100, autoAlpha: 1 });
        gsapApi.set(staggerItems, { autoAlpha: 0, y: 18 });
        setInk(inkClosed);

        openTimeline = gsapApi.timeline({
          defaults: { ease: 'power3.out' },
        });

        openTimeline
          .to(drawer, { xPercent: 0, duration: 0.55 }, 0)
          .to(
            header,
            {
              '--header-ink': colorBlack,
              duration: 0.4,
              ease: 'power2.out',
            },
            0,
          )
          .to(
            staggerItems,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.45,
              stagger: 0.06,
              ease: 'power2.out',
            },
            0.18,
          );
      }

      function closeMenu(gsapApi) {
        if (!isOpen) return;

        const inkClosed = getClosedInk();

        function finish() {
          setOpenState(false);
          clearInkInline();
        }

        if (!gsapApi || prefersReducedMotion()) {
          if (openTimeline) openTimeline.kill();
          drawer.style.transform = '';
          drawer.style.opacity = '';
          drawer.style.visibility = '';
          staggerItems.forEach(function (item) {
            item.style.opacity = '';
            item.style.transform = '';
          });
          finish();
          return;
        }

        if (openTimeline) openTimeline.kill();

        openTimeline = gsapApi.timeline({
          defaults: { ease: 'power3.inOut' },
          onComplete: finish,
        });

        openTimeline
          .to(
            staggerItems,
            {
              autoAlpha: 0,
              y: 10,
              duration: 0.2,
              stagger: { each: 0.03, from: 'end' },
            },
            0,
          )
          .to(
            header,
            {
              '--header-ink': inkClosed,
              duration: 0.3,
              ease: 'power2.in',
            },
            0,
          )
          .to(drawer, { xPercent: -100, duration: 0.4 }, 0.05);
      }

      let gsapApi = null;

      toggle.addEventListener('click', function () {
        if (isOpen) closeMenu(gsapApi);
        else openMenu(gsapApi);
      });

      drawer.addEventListener('click', function (event) {
        if (event.target.closest('a') && isOpen) {
          closeMenu(gsapApi);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen) {
          closeMenu(gsapApi);
          toggle.focus();
        }
      });

      const mediaQuery = window.matchMedia('(min-width: 46.875rem)');
      function handleBreakpoint(event) {
        if (event.matches && isOpen) closeMenu(gsapApi);
      }
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handleBreakpoint);
      } else if (mediaQuery.addListener) {
        mediaQuery.addListener(handleBreakpoint);
      }

      whenGsapReady(function (api) {
        gsapApi = api;
        if (gsapApi) {
          gsapApi.set(drawer, { xPercent: -100, autoAlpha: 0 });
          gsapApi.set(staggerItems, { autoAlpha: 0, y: 18 });
        }
      });
    }

    headers.forEach(initHeader);

    function refreshHeaderInk() {
      headers.forEach(function (header) {
        if (header.classList.contains('is-open')) return;
        header.style.removeProperty('--header-ink');
      });
    }

    window.GiemmaTheme = window.GiemmaTheme || {};
    window.GiemmaTheme.refreshHeaderInk = refreshHeaderInk;

    document.addEventListener('giemma:page:enter', refreshHeaderInk);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var HERO_CANVAS_BREAKPOINT = '(min-width: 46.875rem)';
    var HERO_VISUAL_SELECTOR = '.hero__item-visual';

    // Sticker curl: a perspective tilt on the inner visual layer while dragging.
    // Rotation + lift only — no shadows, no radius — easing back to flat on release.
    var CURL_MAX_TILT = 14; // deg
    var CURL_DISTANCE = 70; // px of drag for a full tilt
    var CURL_RESET_MS = 450; // matches the CSS transition duration
    var curlState = new WeakMap();

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function whenGsapReady(callback) {
      if (typeof gsap !== 'undefined') {
        callback(gsap, typeof Draggable !== 'undefined' ? Draggable : null);
        return;
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (typeof gsap !== 'undefined') {
          clearInterval(timer);
          callback(gsap, typeof Draggable !== 'undefined' ? Draggable : null);
        } else if (attempts > 40) {
          clearInterval(timer);
          callback(null, null);
        }
      }, 50);
    }

    function setLenisStopped(stopped) {
      var lenis = window.GiemmaTheme && window.GiemmaTheme.lenis;
      if (!lenis) return;
      if (stopped) lenis.stop();
      else lenis.start();
    }

    function curlClamp(value) {
      return Math.max(-CURL_MAX_TILT, Math.min(CURL_MAX_TILT, value));
    }

    function curlPointer(instance) {
      var event = instance.pointerEvent;
      var point = event && event.touches && event.touches.length ? event.touches[0] : event;

      if (point && typeof point.clientX === 'number') {
        return { x: point.clientX, y: point.clientY };
      }
      return { x: instance.pointerX, y: instance.pointerY };
    }

    function curlPress(instance, selector) {
      var item = instance.target;
      var visual = item.querySelector(selector);
      if (!visual) return;

      item.classList.remove('is-curled');
      item.classList.add('is-curling');

      // Curl away from the point the sticker is pinched at.
      var rect = item.getBoundingClientRect();
      var pointer = curlPointer(instance);
      var relX = rect.width ? ((pointer.x - rect.left) / rect.width) * 100 : 50;
      var relY = rect.height ? ((pointer.y - rect.top) / rect.height) * 100 : 50;

      visual.style.setProperty('--curl-origin-x', 100 - relX + '%');
      visual.style.setProperty('--curl-origin-y', 100 - relY + '%');

      curlState.set(item, { visual: visual, startX: instance.x, startY: instance.y });
    }

    function curlDrag(instance) {
      var state = curlState.get(instance.target);
      if (!state) return;

      var dx = instance.x - state.startX;
      var dy = instance.y - state.startY;
      var strength = Math.min(1, Math.sqrt(dx * dx + dy * dy) / CURL_DISTANCE);
      var rotateX = curlClamp((dy / CURL_DISTANCE) * CURL_MAX_TILT * -1 * strength);
      var rotateY = curlClamp((dx / CURL_DISTANCE) * CURL_MAX_TILT * strength);
      var lift = 4 + strength * 10;

      state.visual.style.transform =
        'translateZ(' + lift + 'px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
    }

    function curlRelease(instance, selector) {
      var item = instance.target;
      var state = curlState.get(item);
      var visual = state ? state.visual : item.querySelector(selector);

      item.classList.remove('is-curling');
      if (!visual) return;

      item.classList.add('is-curled');
      visual.style.transform = 'translateZ(0) rotateX(0deg) rotateY(0deg)';
      window.setTimeout(function () {
        item.classList.remove('is-curled');
      }, CURL_RESET_MS);
    }

    function setupGraphicReveals(hero, gsapApi) {
      var graphics = Array.prototype.slice.call(hero.querySelectorAll('.hero__item--graphic')).filter(function (item) {
        return item.getClientRects().length > 0;
      });
      var revealCount = 0;

      graphics.forEach(function (item) {
        // The reveal animates the perspective wrapper, leaving the inner visual
        // free for the curl transform during drag.
        var wrap = item.querySelector('.hero__item-visual-wrap');
        var img = item.querySelector('img');
        if (!wrap) return;

        function reveal() {
          if (item.classList.contains('is-revealed')) return;
          item.classList.add('is-revealed');

          if (!gsapApi || prefersReducedMotion()) {
            wrap.style.opacity = '1';
            wrap.style.visibility = 'visible';
            return;
          }

          var delay = revealCount * 0.07;
          revealCount += 1;

          gsapApi.fromTo(
            wrap,
            { autoAlpha: 0, scale: 0.94, y: 14 },
            {
              autoAlpha: 1,
              scale: 1,
              y: 0,
              duration: 0.55,
              delay: delay,
              ease: 'power2.out',
              onComplete: function () {
                wrap.style.willChange = 'auto';
              },
            },
          );
        }

        if (!img) {
          reveal();
          return;
        }

        if (img.complete && img.naturalWidth > 0) {
          reveal();
        } else {
          img.addEventListener('load', reveal, { once: true });
          img.addEventListener('error', reveal, { once: true });
        }
      });
    }

    function initHero(hero) {
      if (!hero || hero.dataset.heroInit === 'true') return;
      hero.dataset.heroInit = 'true';

      var viewport = hero.querySelector('[data-hero-canvas-viewport]');
      var items = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-item]'));
      if (!viewport || !items.length) return;

      var dragEnabled = hero.getAttribute('data-hero-drag') !== 'false';
      var wiggleSeconds = parseFloat(hero.getAttribute('data-hero-wiggle')) || 5;
      var draggables = [];
      var wiggleTimer = null;
      var isDragging = false;
      var maxZ = items.length + 2;

      // The canvas is sized in CSS (design aspect ratio at full width), so JS never
      // touches it — it only keeps the Draggable bounds in sync when the box changes.
      var refreshBoundsHook = null;
      var viewportResizeTimer = null;

      function onViewportResize() {
        // visualViewport also resizes while pinch-zooming — nothing to do then.
        if (window.visualViewport && window.visualViewport.scale > 1) return;

        window.clearTimeout(viewportResizeTimer);
        viewportResizeTimer = window.setTimeout(function () {
          if (refreshBoundsHook) refreshBoundsHook();
        }, 150);
      }

      window.addEventListener('orientationchange', onViewportResize);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', onViewportResize);

      document.addEventListener('shopify:section:unload', function (event) {
        if (!event.target.contains(hero) && event.target !== hero) return;
        window.clearTimeout(viewportResizeTimer);
        window.removeEventListener('orientationchange', onViewportResize);
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', onViewportResize);
      });

      whenGsapReady(function (gsapApi, DraggableApi) {
        if (gsapApi) {
          items.forEach(function (item) {
            var rotation = parseFloat(item.getAttribute('data-rotation')) || 0;
            gsapApi.set(item, { rotation: rotation, x: 0, y: 0, force3D: true });
          });
        }

        setupGraphicReveals(hero, gsapApi);

        // Graphics on the hidden canvas have no layout box, so the reveal pass skips
        // them and they stay at opacity 0. Run it again whenever the breakpoint swaps
        // canvases — otherwise they only appear after a reload.
        var canvasQuery = window.matchMedia(HERO_CANVAS_BREAKPOINT);
        function onCanvasSwap() {
          setupGraphicReveals(hero, gsapApi);
          if (refreshBoundsHook) refreshBoundsHook();
        }
        if (canvasQuery.addEventListener) canvasQuery.addEventListener('change', onCanvasSwap);
        else if (canvasQuery.addListener) canvasQuery.addListener(onCanvasSwap);

        if (!gsapApi || !dragEnabled || prefersReducedMotion() || !DraggableApi) {
          items.forEach(function (item) {
            item.style.cursor = 'default';
          });
          return;
        }

        if (window.GiemmaTheme && !window.GiemmaTheme._draggableRegistered) {
          gsapApi.registerPlugin(DraggableApi);
          window.GiemmaTheme._draggableRegistered = true;
        }

        function overflowAllowance(item) {
          return {
            x: item.offsetWidth * 0.2,
            y: item.offsetHeight * 0.2,
          };
        }

        function boundsForItem(item) {
          var allow = overflowAllowance(item);
          var left = item.offsetLeft;
          var top = item.offsetTop;
          var itemW = item.offsetWidth;
          var itemH = item.offsetHeight;

          var canvas = item.closest('[data-hero-canvas]');
          var stageW = canvas ? canvas.clientWidth : viewport.clientWidth;
          var stageH = canvas ? canvas.clientHeight : viewport.clientHeight;

          return {
            minX: -allow.x - left,
            maxX: stageW + allow.x - left - itemW,
            minY: -allow.y - top,
            maxY: stageH + allow.y - top - itemH,
          };
        }

        function refreshBounds() {
          draggables.forEach(function (instance) {
            instance.applyBounds(boundsForItem(instance.target));
          });
        }

        refreshBoundsHook = refreshBounds;

        draggables = items.map(function (item) {
          return DraggableApi.create(item, {
            type: 'x,y',
            bounds: boundsForItem(item),
            edgeResistance: 0.85,
            inertia: false,
            zIndexBoost: false,
            onPress: function () {
              isDragging = true;
              maxZ += 1;
              this.target.style.zIndex = String(maxZ);
              this.target.classList.add('is-dragging');
              setLenisStopped(true);
              gsapApi.killTweensOf(this.target);
              curlPress(this, HERO_VISUAL_SELECTOR);
            },
            onDrag: function () {
              curlDrag(this);
            },
            onDragEnd: function () {
              isDragging = false;
              this.target.classList.remove('is-dragging');
              setLenisStopped(false);
              curlRelease(this, HERO_VISUAL_SELECTOR);
            },
            onRelease: function () {
              isDragging = false;
              this.target.classList.remove('is-dragging');
              setLenisStopped(false);
              curlRelease(this, HERO_VISUAL_SELECTOR);
            },
          })[0];
        });

        refreshBounds();

        function wiggleOne() {
          if (isDragging || prefersReducedMotion() || !items.length) return;

          var item = items[Math.floor(Math.random() * items.length)];
          if (!item || item.classList.contains('is-dragging')) return;

          var baseRotation = parseFloat(item.getAttribute('data-rotation')) || 0;
          var currentX = gsapApi.getProperty(item, 'x') || 0;
          var currentY = gsapApi.getProperty(item, 'y') || 0;
          var nudgeX = gsapApi.utils.random(-10, 10);
          var nudgeY = gsapApi.utils.random(-8, 8);
          var nudgeR = gsapApi.utils.random(-5, 5);

          gsapApi
            .timeline({
              defaults: { ease: 'power1.inOut' },
            })
            .to(item, {
              x: currentX + nudgeX,
              y: currentY + nudgeY,
              rotation: baseRotation + nudgeR,
              duration: 0.18,
            })
            .to(item, {
              x: currentX - nudgeX * 0.5,
              y: currentY - nudgeY * 0.5,
              rotation: baseRotation - nudgeR * 0.6,
              duration: 0.16,
            })
            .to(item, {
              x: currentX,
              y: currentY,
              rotation: baseRotation,
              duration: 0.22,
              ease: 'power2.out',
            });
        }

        function startWiggle() {
          stopWiggle();
          if (wiggleSeconds <= 0) return;
          wiggleTimer = window.setInterval(wiggleOne, wiggleSeconds * 1000);
        }

        function stopWiggle() {
          if (wiggleTimer) {
            window.clearInterval(wiggleTimer);
            wiggleTimer = null;
          }
        }

        startWiggle();

        var resizeTimer = null;
        function onResize() {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            // Safety net for the canvas swap above (matchMedia can be missed when a
            // resize crosses the breakpoint in one jump).
            setupGraphicReveals(hero, gsapApi);
            items.forEach(function (item) {
              gsapApi.set(item, {
                x: 0,
                y: 0,
                rotation: parseFloat(item.getAttribute('data-rotation')) || 0,
              });
            });
            refreshBounds();
            draggables.forEach(function (instance) {
              instance.update(true);
              instance.applyBounds(boundsForItem(instance.target));
            });
          }, 150);
        }

        window.addEventListener('resize', onResize);

        var mm = window.matchMedia('(prefers-reduced-motion: reduce)');
        function onMotionChange(event) {
          if (event.matches) {
            stopWiggle();
            draggables.forEach(function (instance) {
              instance.disable();
            });
            items.forEach(function (item) {
              item.style.cursor = 'default';
            });
          } else {
            draggables.forEach(function (instance) {
              instance.enable();
            });
            items.forEach(function (item) {
              item.style.cursor = '';
            });
            startWiggle();
          }
        }
        if (mm.addEventListener) mm.addEventListener('change', onMotionChange);
        else if (mm.addListener) mm.addListener(onMotionChange);

        document.addEventListener('shopify:section:unload', function (event) {
          if (!event.target.contains(hero) && event.target !== hero) return;
          stopWiggle();
          window.removeEventListener('resize', onResize);
          draggables.forEach(function (instance) {
            instance.kill();
          });
        });
      });
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-hero]').forEach(initHero);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      var hero = event.target.querySelector('[data-hero]');
      if (hero) initHero(hero);
    });

    document.addEventListener('giemma:page:enter', function (event) {
      initAll(event.detail && event.detail.container);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var JOURNAL_VISUAL_SELECTOR = '.journal-note__visual';

    // Sticker curl: a perspective tilt on the inner visual layer while dragging.
    // Rotation + lift only — no shadows, no radius — easing back to flat on release.
    var CURL_MAX_TILT = 14; // deg
    var CURL_DISTANCE = 70; // px of drag for a full tilt
    var CURL_RESET_MS = 450; // matches the CSS transition duration
    var curlState = new WeakMap();

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function curlClamp(value) {
      return Math.max(-CURL_MAX_TILT, Math.min(CURL_MAX_TILT, value));
    }

    function curlPointer(instance) {
      var event = instance.pointerEvent;
      var point = event && event.touches && event.touches.length ? event.touches[0] : event;

      if (point && typeof point.clientX === 'number') {
        return { x: point.clientX, y: point.clientY };
      }
      return { x: instance.pointerX, y: instance.pointerY };
    }

    function curlPress(instance, selector) {
      var item = instance.target;
      var visual = item.querySelector(selector);
      if (!visual) return;

      item.classList.remove('is-curled');
      item.classList.add('is-curling');

      // Curl away from the point the note is pinched at.
      var rect = item.getBoundingClientRect();
      var pointer = curlPointer(instance);
      var relX = rect.width ? ((pointer.x - rect.left) / rect.width) * 100 : 50;
      var relY = rect.height ? ((pointer.y - rect.top) / rect.height) * 100 : 50;

      visual.style.setProperty('--curl-origin-x', 100 - relX + '%');
      visual.style.setProperty('--curl-origin-y', 100 - relY + '%');

      curlState.set(item, { visual: visual, startX: instance.x, startY: instance.y });
    }

    function curlDrag(instance) {
      var state = curlState.get(instance.target);
      if (!state) return;

      var dx = instance.x - state.startX;
      var dy = instance.y - state.startY;
      var strength = Math.min(1, Math.sqrt(dx * dx + dy * dy) / CURL_DISTANCE);
      var rotateX = curlClamp((dy / CURL_DISTANCE) * CURL_MAX_TILT * -1 * strength);
      var rotateY = curlClamp((dx / CURL_DISTANCE) * CURL_MAX_TILT * strength);
      var lift = 4 + strength * 10;

      state.visual.style.transform =
        'translateZ(' + lift + 'px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
    }

    function curlRelease(instance, selector) {
      var item = instance.target;
      var state = curlState.get(item);
      var visual = state ? state.visual : item.querySelector(selector);

      item.classList.remove('is-curling');
      if (!visual) return;

      item.classList.add('is-curled');
      visual.style.transform = 'translateZ(0) rotateX(0deg) rotateY(0deg)';
      window.setTimeout(function () {
        item.classList.remove('is-curled');
      }, CURL_RESET_MS);
    }

    function whenGsapReady(callback) {
      if (typeof gsap !== 'undefined') {
        callback(gsap, typeof Draggable !== 'undefined' ? Draggable : null);
        return;
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (typeof gsap !== 'undefined') {
          clearInterval(timer);
          callback(gsap, typeof Draggable !== 'undefined' ? Draggable : null);
        } else if (attempts > 40) {
          clearInterval(timer);
          callback(null, null);
        }
      }, 50);
    }

    function setLenisStopped(stopped) {
      var lenis = window.GiemmaTheme && window.GiemmaTheme.lenis;
      if (!lenis) return;
      if (stopped) lenis.stop();
      else lenis.start();
    }

    function initJournal(journal) {
      if (!journal || journal.dataset.journalInit === 'true') return;
      journal.dataset.journalInit = 'true';

      var stage = journal.querySelector('[data-journal-stage]');
      var notes = Array.prototype.slice.call(journal.querySelectorAll('[data-journal-note]'));
      if (!stage || !notes.length) return;

      var dragEnabled = journal.getAttribute('data-journal-drag') !== 'false';
      var wiggleSeconds = parseFloat(journal.getAttribute('data-journal-wiggle')) || 0;
      var draggables = [];
      var wiggleTimer = null;
      var isDragging = false;
      var maxZ = notes.length + 10;

      whenGsapReady(function (gsapApi, DraggableApi) {
        if (gsapApi) {
          notes.forEach(function (item) {
            var rotation = parseFloat(item.getAttribute('data-rotation')) || 0;
            gsapApi.set(item, { rotation: rotation, x: 0, y: 0, force3D: true });
          });
        }

        if (!gsapApi || !dragEnabled || prefersReducedMotion() || !DraggableApi) {
          notes.forEach(function (item) {
            item.style.cursor = 'default';
          });
          return;
        }

        if (window.GiemmaTheme && !window.GiemmaTheme._draggableRegistered) {
          gsapApi.registerPlugin(DraggableApi);
          window.GiemmaTheme._draggableRegistered = true;
        }

        function overflowAllowance(item) {
          return {
            x: item.offsetWidth * 0.35,
            y: item.offsetHeight * 0.35,
          };
        }

        function boundsForItem(item) {
          var allow = overflowAllowance(item);
          var stageRect = stage.getBoundingClientRect();
          var itemRect = item.getBoundingClientRect();
          var currentX = gsapApi.getProperty(item, 'x') || 0;
          var currentY = gsapApi.getProperty(item, 'y') || 0;
          var left = itemRect.left - stageRect.left - currentX;
          var top = itemRect.top - stageRect.top - currentY;
          var itemW = item.offsetWidth;
          var itemH = item.offsetHeight;
          var stageW = stage.clientWidth;
          var stageH = Math.max(stage.clientHeight, stage.scrollHeight);

          return {
            minX: -allow.x - left,
            maxX: stageW + allow.x - left - itemW,
            minY: -allow.y - top,
            maxY: stageH + allow.y - top - itemH,
          };
        }

        function refreshBounds() {
          draggables.forEach(function (instance) {
            instance.applyBounds(boundsForItem(instance.target));
          });
        }

        draggables = notes.map(function (item) {
          return DraggableApi.create(item, {
            type: 'x,y',
            bounds: boundsForItem(item),
            edgeResistance: 0.85,
            inertia: false,
            zIndexBoost: false,
            onPress: function () {
              isDragging = true;
              maxZ += 1;
              this.target.style.zIndex = String(maxZ);
              this.target.classList.add('is-dragging');
              setLenisStopped(true);
              gsapApi.killTweensOf(this.target);
              curlPress(this, JOURNAL_VISUAL_SELECTOR);
            },
            onDrag: function () {
              curlDrag(this);
            },
            onDragEnd: function () {
              isDragging = false;
              this.target.classList.remove('is-dragging');
              setLenisStopped(false);
              curlRelease(this, JOURNAL_VISUAL_SELECTOR);
            },
            onRelease: function () {
              isDragging = false;
              this.target.classList.remove('is-dragging');
              setLenisStopped(false);
              curlRelease(this, JOURNAL_VISUAL_SELECTOR);
            },
          })[0];
        });

        refreshBounds();

        function wiggleOne() {
          if (isDragging || prefersReducedMotion() || !notes.length) return;

          var item = notes[Math.floor(Math.random() * notes.length)];
          if (!item || item.classList.contains('is-dragging')) return;

          var baseRotation = parseFloat(item.getAttribute('data-rotation')) || 0;
          var currentX = gsapApi.getProperty(item, 'x') || 0;
          var currentY = gsapApi.getProperty(item, 'y') || 0;
          var nudgeX = gsapApi.utils.random(-8, 8);
          var nudgeY = gsapApi.utils.random(-6, 6);
          var nudgeR = gsapApi.utils.random(-3, 3);

          gsapApi
            .timeline({ defaults: { ease: 'power1.inOut' } })
            .to(item, {
              x: currentX + nudgeX,
              y: currentY + nudgeY,
              rotation: baseRotation + nudgeR,
              duration: 0.18,
            })
            .to(item, {
              x: currentX - nudgeX * 0.5,
              y: currentY - nudgeY * 0.5,
              rotation: baseRotation - nudgeR * 0.6,
              duration: 0.16,
            })
            .to(item, {
              x: currentX,
              y: currentY,
              rotation: baseRotation,
              duration: 0.22,
              ease: 'power2.out',
            });
        }

        function startWiggle() {
          stopWiggle();
          if (wiggleSeconds <= 0) return;
          wiggleTimer = window.setInterval(wiggleOne, wiggleSeconds * 1000);
        }

        function stopWiggle() {
          if (wiggleTimer) {
            window.clearInterval(wiggleTimer);
            wiggleTimer = null;
          }
        }

        startWiggle();

        var resizeTimer = null;
        var lastStageWidth = stage.clientWidth;
        function onResize() {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            var stageWidth = stage.clientWidth;
            var widthChanged = stageWidth !== lastStageWidth;
            lastStageWidth = stageWidth;

            if (widthChanged) {
              notes.forEach(function (item) {
                gsapApi.set(item, {
                  x: 0,
                  y: 0,
                  rotation: parseFloat(item.getAttribute('data-rotation')) || 0,
                });
              });
            }

            refreshBounds();
            draggables.forEach(function (instance) {
              instance.update(true);
              instance.applyBounds(boundsForItem(instance.target));
            });
          }, 150);
        }

        window.addEventListener('resize', onResize);

        var mm = window.matchMedia('(prefers-reduced-motion: reduce)');
        function onMotionChange(event) {
          if (event.matches) {
            stopWiggle();
            draggables.forEach(function (instance) {
              instance.disable();
            });
            notes.forEach(function (item) {
              item.style.cursor = 'default';
            });
          } else {
            draggables.forEach(function (instance) {
              instance.enable();
            });
            notes.forEach(function (item) {
              item.style.cursor = '';
            });
            startWiggle();
          }
        }
        if (mm.addEventListener) mm.addEventListener('change', onMotionChange);
        else if (mm.addListener) mm.addListener(onMotionChange);

        document.addEventListener('shopify:section:unload', function (event) {
          if (!event.target.contains(journal) && event.target !== journal) return;
          stopWiggle();
          window.removeEventListener('resize', onResize);
          draggables.forEach(function (instance) {
            instance.kill();
          });
        });
      });
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-journal]').forEach(initJournal);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      var journal = event.target.querySelector('[data-journal]');
      if (journal) initJournal(journal);
    });

    document.addEventListener('giemma:page:enter', function (event) {
      initAll(event.detail && event.detail.container);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  // Newsletter uses theme.liquid (Barba + theme.js). Re-init on page enter.
  (function () {
    var NEWSLETTER_VISUAL_SELECTOR = '.newsletter__item-visual';
    var NEWSLETTER_CLUSTER_VISUAL_SELECTOR = '.newsletter__mobile-cluster-visual';

    // Sticker curl: a perspective tilt on the inner visual layer while dragging.
    // Rotation + lift only — no shadows, no radius — easing back to flat on release.
    var CURL_MAX_TILT = 14; // deg
    var CURL_DISTANCE = 70; // px of drag for a full tilt
    var CURL_RESET_MS = 450; // matches the CSS transition duration
    var curlState = new WeakMap();

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function curlClamp(value) {
      return Math.max(-CURL_MAX_TILT, Math.min(CURL_MAX_TILT, value));
    }

    function curlPointer(instance) {
      var event = instance.pointerEvent;
      var point = event && event.touches && event.touches.length ? event.touches[0] : event;

      if (point && typeof point.clientX === 'number') {
        return { x: point.clientX, y: point.clientY };
      }
      return { x: instance.pointerX, y: instance.pointerY };
    }

    function curlPress(instance, selector) {
      var item = instance.target;
      var visual = item.querySelector(selector);
      if (!visual) return;

      item.classList.remove('is-curled');
      item.classList.add('is-curling');

      // Curl away from the point the sticker is pinched at.
      var rect = item.getBoundingClientRect();
      var pointer = curlPointer(instance);
      var relX = rect.width ? ((pointer.x - rect.left) / rect.width) * 100 : 50;
      var relY = rect.height ? ((pointer.y - rect.top) / rect.height) * 100 : 50;

      visual.style.setProperty('--curl-origin-x', 100 - relX + '%');
      visual.style.setProperty('--curl-origin-y', 100 - relY + '%');

      curlState.set(item, { visual: visual, startX: instance.x, startY: instance.y });
    }

    function curlDrag(instance) {
      var state = curlState.get(instance.target);
      if (!state) return;

      var dx = instance.x - state.startX;
      var dy = instance.y - state.startY;
      var strength = Math.min(1, Math.sqrt(dx * dx + dy * dy) / CURL_DISTANCE);
      var rotateX = curlClamp((dy / CURL_DISTANCE) * CURL_MAX_TILT * -1 * strength);
      var rotateY = curlClamp((dx / CURL_DISTANCE) * CURL_MAX_TILT * strength);
      var lift = 4 + strength * 10;

      state.visual.style.transform =
        'translateZ(' + lift + 'px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
    }

    function curlRelease(instance, selector) {
      var item = instance.target;
      var state = curlState.get(item);
      var visual = state ? state.visual : item.querySelector(selector);

      item.classList.remove('is-curling');
      if (!visual) return;

      item.classList.add('is-curled');
      visual.style.transform = 'translateZ(0) rotateX(0deg) rotateY(0deg)';
      window.setTimeout(function () {
        item.classList.remove('is-curled');
      }, CURL_RESET_MS);
    }

    function whenGsapReady(callback) {
      if (typeof gsap !== 'undefined') {
        callback(gsap, typeof Draggable !== 'undefined' ? Draggable : null);
        return;
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (typeof gsap !== 'undefined') {
          clearInterval(timer);
          callback(gsap, typeof Draggable !== 'undefined' ? Draggable : null);
        } else if (attempts > 40) {
          clearInterval(timer);
          callback(null, null);
        }
      }, 50);
    }

    function initNewsletterDrag(root) {
      var stage = root.querySelector('[data-newsletter-stage]');
      var canvasViewport = root.querySelector('[data-newsletter-canvas-viewport]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-newsletter-item]'));
      if (!stage || !canvasViewport || !items.length) return;

      var dragEnabled = root.getAttribute('data-newsletter-drag') !== 'false';
      var wiggleSeconds = parseFloat(root.getAttribute('data-newsletter-wiggle')) || 5;
      var draggables = [];
      var wiggleTimer = null;
      var isDragging = false;
      var maxZ = 20;
      var ITEM_MAX_Z = 40;

      // The canvas is sized in CSS (design aspect ratio at full width), so JS never
      // touches it — it only keeps the Draggable bounds in sync when the box changes.
      var refreshBoundsHook = null;
      var viewportResizeTimer = null;

      function onViewportResize() {
        // visualViewport also resizes while pinch-zooming — nothing to do then.
        if (window.visualViewport && window.visualViewport.scale > 1) return;

        window.clearTimeout(viewportResizeTimer);
        viewportResizeTimer = window.setTimeout(function () {
          if (refreshBoundsHook) refreshBoundsHook();
        }, 150);
      }

      window.addEventListener('orientationchange', onViewportResize);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', onViewportResize);

      document.addEventListener('shopify:section:unload', function (event) {
        if (!event.target.contains(root) && event.target !== root) return;
        window.clearTimeout(viewportResizeTimer);
        window.removeEventListener('orientationchange', onViewportResize);
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', onViewportResize);
      });

      whenGsapReady(function (gsapApi, DraggableApi) {
        if (gsapApi) {
          items.forEach(function (item) {
            var rotation = parseFloat(item.getAttribute('data-rotation')) || 0;
            gsapApi.set(item, { rotation: rotation, x: 0, y: 0, force3D: true });
          });
        }

        if (!gsapApi || !dragEnabled || prefersReducedMotion() || !DraggableApi) {
          items.forEach(function (item) {
            item.style.cursor = 'default';
          });
          return;
        }

        if (window.GiemmaTheme && !window.GiemmaTheme._draggableRegistered) {
          gsapApi.registerPlugin(DraggableApi);
          window.GiemmaTheme._draggableRegistered = true;
        } else if (!window.GiemmaTheme) {
          gsapApi.registerPlugin(DraggableApi);
        }

        function isVisible(item) {
          return item.getClientRects().length > 0;
        }

        function overflowAllowance(item) {
          var canvas = item.closest('[data-newsletter-canvas]');
          var canvasW = canvas ? canvas.clientWidth : stage.clientWidth;
          var canvasH = canvas ? canvas.clientHeight : stage.clientHeight;

          return {
            x: Math.min(item.offsetWidth * 0.2, canvasW * 0.08),
            y: Math.min(item.offsetHeight * 0.2, canvasH * 0.08),
          };
        }

        function boundsForItem(item) {
          var canvas = item.closest('[data-newsletter-canvas]');
          var allow = overflowAllowance(item);
          var left = item.offsetLeft;
          var top = item.offsetTop;
          var itemW = item.offsetWidth;
          var itemH = item.offsetHeight;
          var stageW = canvas ? canvas.clientWidth : stage.clientWidth;
          var stageH = canvas ? canvas.clientHeight : stage.clientHeight;

          return {
            minX: -allow.x - left,
            maxX: stageW + allow.x - left - itemW,
            minY: -allow.y - top,
            maxY: stageH + allow.y - top - itemH,
          };
        }

        function refreshBounds() {
          draggables.forEach(function (instance) {
            if (!isVisible(instance.target)) {
              instance.disable();
              return;
            }
            instance.enable();
            instance.applyBounds(boundsForItem(instance.target));
          });
        }

        refreshBoundsHook = refreshBounds;

        draggables = items.map(function (item) {
          return DraggableApi.create(item, {
            type: 'x,y',
            bounds: boundsForItem(item),
            edgeResistance: 0.85,
            inertia: false,
            zIndexBoost: false,
            onPress: function () {
              isDragging = true;
              maxZ = Math.min(maxZ + 1, ITEM_MAX_Z);
              this.target.style.zIndex = String(maxZ);
              this.target.classList.add('is-dragging');
              gsapApi.killTweensOf(this.target);
              curlPress(this, NEWSLETTER_VISUAL_SELECTOR);
            },
            onDrag: function () {
              curlDrag(this);
            },
            onDragEnd: function () {
              isDragging = false;
              this.target.classList.remove('is-dragging');
              curlRelease(this, NEWSLETTER_VISUAL_SELECTOR);
            },
            onRelease: function () {
              isDragging = false;
              this.target.classList.remove('is-dragging');
              curlRelease(this, NEWSLETTER_VISUAL_SELECTOR);
            },
          })[0];
        });

        refreshBounds();

        function wiggleOne() {
          if (isDragging || prefersReducedMotion() || !items.length) return;

          var visible = items.filter(isVisible);
          if (!visible.length) return;

          var item = visible[Math.floor(Math.random() * visible.length)];
          if (!item || item.classList.contains('is-dragging')) return;

          var baseRotation = parseFloat(item.getAttribute('data-rotation')) || 0;
          var currentX = gsapApi.getProperty(item, 'x') || 0;
          var currentY = gsapApi.getProperty(item, 'y') || 0;
          var nudgeX = gsapApi.utils.random(-10, 10);
          var nudgeY = gsapApi.utils.random(-8, 8);
          var nudgeR = gsapApi.utils.random(-5, 5);

          gsapApi
            .timeline({
              defaults: { ease: 'power1.inOut' },
            })
            .to(item, {
              x: currentX + nudgeX,
              y: currentY + nudgeY,
              rotation: baseRotation + nudgeR,
              duration: 0.18,
            })
            .to(item, {
              x: currentX - nudgeX * 0.5,
              y: currentY - nudgeY * 0.5,
              rotation: baseRotation - nudgeR * 0.6,
              duration: 0.16,
            })
            .to(item, {
              x: currentX,
              y: currentY,
              rotation: baseRotation,
              duration: 0.22,
              ease: 'power2.out',
            });
        }

        function startWiggle() {
          stopWiggle();
          if (wiggleSeconds <= 0) return;
          wiggleTimer = window.setInterval(wiggleOne, wiggleSeconds * 1000);
        }

        function stopWiggle() {
          if (wiggleTimer) {
            window.clearInterval(wiggleTimer);
            wiggleTimer = null;
          }
        }

        startWiggle();

        var resizeTimer = null;
        function onResize() {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            items.forEach(function (item) {
              gsapApi.set(item, {
                x: 0,
                y: 0,
                rotation: parseFloat(item.getAttribute('data-rotation')) || 0,
              });
            });
            refreshBounds();
            draggables.forEach(function (instance) {
              instance.update(true);
              if (isVisible(instance.target)) {
                instance.applyBounds(boundsForItem(instance.target));
              }
            });
          }, 150);
        }

        window.addEventListener('resize', onResize);

        var mm = window.matchMedia('(prefers-reduced-motion: reduce)');
        function onMotionChange(event) {
          if (event.matches) {
            stopWiggle();
            draggables.forEach(function (instance) {
              instance.disable();
            });
            items.forEach(function (item) {
              item.style.cursor = 'default';
            });
          } else {
            refreshBounds();
            items.forEach(function (item) {
              item.style.cursor = '';
            });
            startWiggle();
          }
        }
        if (mm.addEventListener) mm.addEventListener('change', onMotionChange);
        else if (mm.addListener) mm.addListener(onMotionChange);

        document.addEventListener('shopify:section:unload', function (event) {
          if (!event.target.contains(root) && event.target !== root) return;
          stopWiggle();
          window.removeEventListener('resize', onResize);
          draggables.forEach(function (instance) {
            instance.kill();
          });
        });
      });
    }

    function initNewsletterMobileClusterDrag(root) {
      var container = root.querySelector('.newsletter__mobile-close');
      var cluster = root.querySelector('[data-newsletter-mobile-cluster]');
      if (!container || !cluster) return;

      var dragEnabled = root.getAttribute('data-newsletter-drag') !== 'false';
      var mobileQuery = window.matchMedia('(max-width: 46.874rem)');
      var draggableInstance = null;
      var resizeTimer = null;

      function isMobile() {
        return mobileQuery.matches;
      }

      function overflowAllowance() {
        return {
          x: Math.min(cluster.offsetWidth * 0.2, container.clientWidth * 0.12),
          y: Math.min(cluster.offsetHeight * 0.2, container.clientHeight * 0.12),
        };
      }

      function boundsForCluster() {
        var allow = overflowAllowance();
        var left = cluster.offsetLeft;
        var top = cluster.offsetTop;
        var clusterW = cluster.offsetWidth;
        var clusterH = cluster.offsetHeight;
        var containerW = container.clientWidth;
        var containerH = container.clientHeight;

        return {
          minX: -allow.x - left,
          maxX: containerW + allow.x - left - clusterW,
          minY: -allow.y - top,
          maxY: containerH + allow.y - top - clusterH,
        };
      }

      function setClusterCursor(enabled) {
        cluster.style.cursor = enabled ? 'grab' : 'default';
      }

      function destroyDraggable() {
        if (draggableInstance) {
          draggableInstance.kill();
          draggableInstance = null;
        }
      }

      function resetCluster() {
        if (typeof gsap !== 'undefined') {
          gsap.set(cluster, { x: 0, y: 0, force3D: true });
        }
        cluster.classList.remove('is-dragging');

        // The Draggable can be killed mid-drag on a breakpoint change, so flatten
        // the curl here instead of relying on onRelease.
        cluster.classList.remove('is-curling');
        cluster.classList.remove('is-curled');
        var visual = cluster.querySelector(NEWSLETTER_CLUSTER_VISUAL_SELECTOR);
        if (visual) visual.style.transform = 'translateZ(0) rotateX(0deg) rotateY(0deg)';
      }

      whenGsapReady(function (gsapApi, DraggableApi) {
        gsapApi.set(cluster, { x: 0, y: 0, force3D: true });

        if (!gsapApi || !dragEnabled || prefersReducedMotion() || !DraggableApi) {
          setClusterCursor(false);
          return;
        }

        if (window.GiemmaTheme && !window.GiemmaTheme._draggableRegistered) {
          gsapApi.registerPlugin(DraggableApi);
          window.GiemmaTheme._draggableRegistered = true;
        } else if (!window.GiemmaTheme) {
          gsapApi.registerPlugin(DraggableApi);
        }

        function refreshClusterDrag() {
          if (!isMobile()) {
            destroyDraggable();
            resetCluster();
            setClusterCursor(false);
            return;
          }

          setClusterCursor(true);

          if (!draggableInstance) {
            draggableInstance = DraggableApi.create(cluster, {
              type: 'x,y',
              bounds: boundsForCluster(),
              edgeResistance: 0.85,
              inertia: false,
              zIndexBoost: false,
              onPress: function () {
                this.target.classList.add('is-dragging');
                gsapApi.killTweensOf(this.target);
                curlPress(this, NEWSLETTER_CLUSTER_VISUAL_SELECTOR);
              },
              onDrag: function () {
                curlDrag(this);
              },
              onDragEnd: function () {
                this.target.classList.remove('is-dragging');
                curlRelease(this, NEWSLETTER_CLUSTER_VISUAL_SELECTOR);
              },
              onRelease: function () {
                this.target.classList.remove('is-dragging');
                curlRelease(this, NEWSLETTER_CLUSTER_VISUAL_SELECTOR);
              },
            })[0];
          } else {
            draggableInstance.enable();
            draggableInstance.applyBounds(boundsForCluster());
          }
        }

        refreshClusterDrag();

        function onResize() {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            resetCluster();
            refreshClusterDrag();
            if (draggableInstance) {
              draggableInstance.update(true);
              draggableInstance.applyBounds(boundsForCluster());
            }
          }, 150);
        }

        function onBreakpointChange() {
          resetCluster();
          refreshClusterDrag();
        }

        window.addEventListener('resize', onResize);
        if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpointChange);
        else if (mobileQuery.addListener) mobileQuery.addListener(onBreakpointChange);

        var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        function onMotionChange(event) {
          if (event.matches) {
            destroyDraggable();
            resetCluster();
            setClusterCursor(false);
          } else {
            refreshClusterDrag();
          }
        }
        if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
        else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);

        document.addEventListener('shopify:section:unload', function (event) {
          if (!event.target.contains(root) && event.target !== root) return;
          window.removeEventListener('resize', onResize);
          if (mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', onBreakpointChange);
          else if (mobileQuery.removeListener) mobileQuery.removeListener(onBreakpointChange);
          if (motionQuery.removeEventListener) motionQuery.removeEventListener('change', onMotionChange);
          else if (motionQuery.removeListener) motionQuery.removeListener(onMotionChange);
          destroyDraggable();
        });
      });
    }

    function destroyNewsletter(root) {
      if (!root) return;
      root.dataset.newsletterInit = 'false';
    }

    function initNewsletter(root) {
      if (!root || root.dataset.newsletterInit === 'true') return;
      root.dataset.newsletterInit = 'true';
      initNewsletterDrag(root);
      initNewsletterMobileClusterDrag(root);
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-newsletter]').forEach(initNewsletter);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-newsletter]');
      if (section) initNewsletter(section);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target.querySelector('[data-newsletter]');
      if (section) destroyNewsletter(section);
    });

    document.addEventListener('giemma:page:enter', function (event) {
      initAll(event.detail && event.detail.container);
    });

    document.addEventListener('giemma:page:leave', function (event) {
      var container = event.detail && event.detail.container;
      if (!container) return;
      container.querySelectorAll('[data-newsletter]').forEach(destroyNewsletter);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPasswordSecret(root) {
      var secret = root.querySelector('[data-password-secret]');
      var dialog = root.querySelector('[data-password-dialog]');
      if (!secret || !dialog) return;

      var CLICKS_NEEDED = 3;
      var WINDOW_MS = 2000;
      var clicks = 0;
      var timer = null;

      function openDialog() {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        var input = dialog.querySelector('input[type="password"]');
        if (input) input.focus();
      }

      secret.addEventListener('click', function () {
        clicks += 1;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          clicks = 0;
        }, WINDOW_MS);

        if (clicks >= CLICKS_NEEDED) {
          clicks = 0;
          if (timer) clearTimeout(timer);
          openDialog();
        }
      });

      if (dialog.querySelector('.password__login-errors')) {
        openDialog();
      }
    }

    document.querySelectorAll('[data-password]').forEach(function (root) {
      initPasswordSecret(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function whenGsapReady(callback) {
      if (typeof gsap !== 'undefined') {
        callback(gsap);
        return;
      }
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (typeof gsap !== 'undefined') {
          clearInterval(timer);
          callback(gsap);
        } else if (tries > 40) {
          clearInterval(timer);
          callback(null);
        }
      }, 50);
    }

    function parseProductJson(root) {
      var node = root.querySelector('[data-product-json]');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    function parseVariantMediaMap(root) {
      var node = root.querySelector('[data-variant-media]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent) || {};
      } catch (error) {
        return {};
      }
    }

    function getColorOptionIndex(product) {
      if (!product || !product.options) return -1;
      for (var i = 0; i < product.options.length; i++) {
        var name = String(product.options[i] || '').toLowerCase();
        if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) {
          return i;
        }
      }
      return -1;
    }

    function mediaEntryHasTarget(entry) {
      return !!(entry && (entry.mediaId || entry.imageId));
    }

    function resolveVariantMedia(product, variant, variantMediaMap) {
      if (!variant) return null;

      var direct = variantMediaMap[String(variant.id)];
      if (mediaEntryHasTarget(direct)) return direct;

      if (variant.featured_image && variant.featured_image.id) {
        return { mediaId: null, imageId: variant.featured_image.id };
      }

      var colorIndex = getColorOptionIndex(product);
      if (colorIndex < 0 || !variant.options) return direct || null;

      var colorValue = variant.options[colorIndex];
      for (var i = 0; i < product.variants.length; i++) {
        var sibling = product.variants[i];
        if (!sibling || !sibling.options) continue;
        if (sibling.options[colorIndex] !== colorValue) continue;
        var siblingMedia = variantMediaMap[String(sibling.id)];
        if (mediaEntryHasTarget(siblingMedia)) return siblingMedia;
        if (sibling.featured_image && sibling.featured_image.id) {
          return { mediaId: null, imageId: sibling.featured_image.id };
        }
      }

      return direct || null;
    }

    function getSelectedOptions(form) {
      var values = [];
      form.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input[data-option-input]:checked');
        if (checked) {
          values.push(checked.value);
          return;
        }

        var inputs = fieldset.querySelectorAll('input[data-option-input]');
        if (inputs.length === 1) {
          values.push(inputs[0].value);
          return;
        }

        values.push(null);
      });
      return values;
    }

    function findVariant(product, selectedOptions) {
      if (!product || !product.variants) return null;
      if (
        selectedOptions.some(function (value) {
          return value == null;
        })
      ) {
        return null;
      }
      return (
        product.variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
        }) || null
      );
    }

    function formatMoney(cents) {
      return (Number(cents) / 100).toFixed(0);
    }

    function initSlider(root) {
      var media = root.querySelector('[data-product-media]');
      var slider = root.querySelector('[data-media-slider]');
      if (!slider) return null;

      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-media-dot]'));
      var desktopMq = window.matchMedia('(min-width: 46.875rem)');
      var index = 0;
      var drag = {
        active: false,
        startX: 0,
        startY: 0,
        deltaX: 0,
        locking: null,
        pointerId: null,
      };
      var swipeBound = false;

      function isDesktopStack() {
        return desktopMq.matches;
      }

      function getWidth() {
        return (media && media.clientWidth) || slider.clientWidth || 1;
      }

      function offsetFor(i, dragX) {
        return -i * getWidth() + (dragX || 0);
      }

      function clearTransform() {
        var gsapApi = window.gsap;
        if (gsapApi) {
          gsapApi.set(slider, { clearProps: 'transform,x' });
        }
        slider.style.transform = '';
      }

      function revealAllSlides() {
        slides.forEach(function (slide) {
          slide.setAttribute('aria-hidden', 'false');
        });
      }

      function syncDots() {
        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function scrollToSlide(i, animate) {
        var slide = slides[i];
        if (!slide) return;
        index = i;
        syncDots();
        revealAllSlides();

        var reduce = prefersReducedMotion();
        var top = slide.getBoundingClientRect().top + window.scrollY;

        if (animate === false || reduce) {
          window.scrollTo(0, top);
          return;
        }

        var lenis = window.GiemmaTheme && window.GiemmaTheme.lenis;
        if (lenis && typeof lenis.scrollTo === 'function') {
          lenis.scrollTo(top, { duration: 0.7 });
          return;
        }

        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      function setIndex(nextIndex, animate) {
        index = Math.max(0, Math.min(slides.length - 1, nextIndex));

        if (isDesktopStack()) {
          clearTransform();
          revealAllSlides();
          syncDots();
          if (animate) scrollToSlide(index, true);
          return;
        }

        var x = offsetFor(index, 0);
        var reduce = prefersReducedMotion();
        var gsapApi = window.gsap;

        if (gsapApi && animate !== false && !reduce) {
          gsapApi.to(slider, {
            x: x,
            duration: 0.4,
            ease: 'power2.out',
            overwrite: 'auto',
          });
        } else if (gsapApi) {
          gsapApi.set(slider, { x: x });
        } else {
          slider.style.transform = 'translate3d(' + x + 'px, 0, 0)';
        }

        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        syncDots();
      }

      function stopLenis() {
        var lenis = window.GiemmaTheme && window.GiemmaTheme.lenis;
        if (lenis && typeof lenis.stop === 'function') lenis.stop();
      }

      function startLenis() {
        var lenis = window.GiemmaTheme && window.GiemmaTheme.lenis;
        if (lenis && typeof lenis.start === 'function') lenis.start();
      }

      function onPointerDown(event) {
        if (isDesktopStack()) return;
        if (event.button != null && event.button !== 0) return;
        drag.active = true;
        drag.startX = event.clientX;
        drag.startY = event.clientY;
        drag.deltaX = 0;
        drag.locking = null;
        drag.pointerId = event.pointerId;
        slider.classList.add('is-dragging');
        try {
          slider.setPointerCapture(event.pointerId);
        } catch (error) {}
      }

      function onPointerMove(event) {
        if (isDesktopStack() || !drag.active) return;
        var dx = event.clientX - drag.startX;
        var dy = event.clientY - drag.startY;

        if (drag.locking == null && (Math.abs(dx) > 4 || Math.abs(dy) > 4)) {
          drag.locking = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (drag.locking === 'x') stopLenis();
        }

        if (drag.locking === 'y') return;
        if (drag.locking !== 'x') return;

        event.preventDefault();
        drag.deltaX = dx;

        var atStart = index === 0 && dx > 0;
        var atEnd = index === slides.length - 1 && dx < 0;
        var resistance = atStart || atEnd ? 0.35 : 1;
        var x = offsetFor(index, dx * resistance);
        var gsapApi = window.gsap;

        if (gsapApi) {
          gsapApi.set(slider, { x: x });
        } else {
          slider.style.transform = 'translate3d(' + x + 'px, 0, 0)';
        }
      }

      function onPointerUp(event) {
        if (isDesktopStack() || !drag.active) return;
        var wasHorizontal = drag.locking === 'x';
        var delta = drag.deltaX;
        drag.active = false;
        drag.locking = null;
        slider.classList.remove('is-dragging');
        startLenis();

        if (event && drag.pointerId != null) {
          try {
            slider.releasePointerCapture(drag.pointerId);
          } catch (error) {}
          drag.pointerId = null;
        }

        if (!wasHorizontal) {
          setIndex(index, false);
          return;
        }

        var threshold = Math.min(80, getWidth() * 0.18);
        if (delta <= -threshold) {
          setIndex(index + 1, true);
        } else if (delta >= threshold) {
          setIndex(index - 1, true);
        } else {
          setIndex(index, true);
        }
      }

      function bindSwipe() {
        if (swipeBound || slides.length < 2) return;
        slider.addEventListener('pointerdown', onPointerDown);
        slider.addEventListener('pointermove', onPointerMove, { passive: false });
        slider.addEventListener('pointerup', onPointerUp);
        slider.addEventListener('pointercancel', onPointerUp);
        swipeBound = true;
      }

      function onKeydown(event) {
        if (isDesktopStack()) return;
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setIndex(index + 1, true);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setIndex(index - 1, true);
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          setIndex(Number(dot.getAttribute('data-index')) || 0, true);
        });
      });

      slider.addEventListener('keydown', onKeydown);
      bindSwipe();

      function onBreakpointChange() {
        if (isDesktopStack()) {
          clearTransform();
          revealAllSlides();
          syncDots();
        } else {
          setIndex(index, false);
        }
      }

      if (typeof desktopMq.addEventListener === 'function') {
        desktopMq.addEventListener('change', onBreakpointChange);
      } else if (typeof desktopMq.addListener === 'function') {
        desktopMq.addListener(onBreakpointChange);
      }

      window.addEventListener('resize', function () {
        if (!isDesktopStack()) setIndex(index, false);
      });

      if (slides.length < 2) {
        if (isDesktopStack()) {
          clearTransform();
          revealAllSlides();
        }
        return {
          goToMedia: function () {},
          goToImageId: function () {},
        };
      }

      setIndex(0, false);

      return {
        goToMedia: function (mediaId, imageId, animate) {
          var match = -1;

          if (mediaId) {
            match = slides.findIndex(function (slide) {
              return String(slide.getAttribute('data-media-id')) === String(mediaId);
            });
          }

          if (match < 0 && imageId) {
            match = slides.findIndex(function (slide) {
              return String(slide.getAttribute('data-image-id')) === String(imageId);
            });
          }

          if (match < 0) return;

          if (isDesktopStack()) {
            scrollToSlide(match, animate !== false);
            return;
          }

          setIndex(match, animate !== false);
        },
        goToImageId: function (imageId, animate) {
          this.goToMedia(null, imageId, animate);
        },
      };
    }

    function initForm(root, sliderApi) {
      var form = root.querySelector('[data-product-form]');
      var product = parseProductJson(root);
      if (!form || !product) return;

      var variantMediaMap = parseVariantMediaMap(root);
      var variantInput = form.querySelector('[data-variant-id]');
      var submit = form.querySelector('[data-add-to-bag]');
      var quickBuy = form.querySelector('[data-quick-buy]');
      var price = root.querySelector('[data-product-price]');
      var currency = root.getAttribute('data-currency') || '';
      var addLabel = root.getAttribute('data-add-label') || 'Add to bag';
      var soldOutLabel = root.getAttribute('data-sold-out-label') || 'Sold out';
      var hasSynced = false;

      function sync() {
        var selected = getSelectedOptions(form);
        var variant = findVariant(product, selected);
        var animateGallery = hasSynced;

        form.querySelectorAll('[data-option-color]').forEach(function (fieldset) {
          var checked = fieldset.querySelector('input[data-option-input]:checked');
          var label = fieldset.querySelector('[data-selected-option]');
          if (checked && label) label.textContent = checked.value;
          fieldset.querySelectorAll('.product-page__swatch').forEach(function (swatch) {
            var input = swatch.querySelector('input[data-option-input]');
            if (!input) return;
            swatch.classList.toggle('is-selected', input.checked);
          });
        });

        if (!variant || !variantInput) {
          if (submit && submit.getAttribute('aria-busy') !== 'true') {
            submit.disabled = true;
            submit.textContent = soldOutLabel;
          }
          if (quickBuy && quickBuy.getAttribute('aria-busy') !== 'true') {
            quickBuy.disabled = true;
          }
          hasSynced = true;
          return;
        }

        variantInput.value = variant.id;

        if (price) {
          price.innerHTML =
            formatMoney(variant.price) + ' <span class="product-page__currency">' + currency + '</span>';
        }

        if (submit && submit.getAttribute('aria-busy') !== 'true') {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? addLabel : soldOutLabel;
        }
        if (quickBuy && quickBuy.getAttribute('aria-busy') !== 'true') {
          quickBuy.disabled = !variant.available;
        }

        if (sliderApi) {
          var mediaTarget = resolveVariantMedia(product, variant, variantMediaMap);

          if (!mediaEntryHasTarget(mediaTarget)) {
            var colorInput = form.querySelector('[data-option-color] input[data-option-input]:checked');
            if (colorInput) {
              mediaTarget = {
                mediaId: colorInput.getAttribute('data-option-media-id'),
                imageId: colorInput.getAttribute('data-option-image-id'),
              };
            }
          }

          if (mediaEntryHasTarget(mediaTarget)) {
            sliderApi.goToMedia(mediaTarget.mediaId, mediaTarget.imageId, animateGallery);
          }
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        hasSynced = true;
      }

      form.querySelectorAll('[data-option-input]').forEach(function (input) {
        input.addEventListener('change', sync);
      });

      sync();
    }

    function initBagCursor(root) {
      var buttons = root.querySelectorAll('[data-add-to-bag], [data-quick-buy]');
      var bag = root.querySelector('[data-bag-illustration]');
      if (!buttons.length || !bag) return;
      if (window.matchMedia('(hover: none)').matches) return;

      if (bag.parentElement !== document.body) {
        document.body.appendChild(bag);
      }

      var active = false;
      var hideTimer = null;
      var xTo = null;
      var yTo = null;

      whenGsapReady(function (gsapApi) {
        if (gsapApi) {
          gsapApi.set(bag, { xPercent: -50, yPercent: -50, x: 0, y: 0, autoAlpha: 0 });
          xTo = gsapApi.quickTo(bag, 'x', { duration: 0.18, ease: 'power3.out' });
          yTo = gsapApi.quickTo(bag, 'y', { duration: 0.18, ease: 'power3.out' });
        }

        function moveBag(clientX, clientY, immediate) {
          if (!gsapApi) {
            bag.style.left = '0px';
            bag.style.top = '0px';
            bag.style.transform = 'translate(' + clientX + 'px, ' + clientY + 'px) translate(-50%, -50%)';
            return;
          }
          if (immediate) {
            gsapApi.set(bag, { x: clientX, y: clientY });
          } else if (xTo && yTo) {
            xTo(clientX);
            yTo(clientY);
          }
        }

        function showBag(clientX, clientY) {
          if (hideTimer) {
            clearTimeout(hideTimer);
            hideTimer = null;
          }
          active = true;
          root.classList.add('is-bag-cursor');
          bag.classList.add('is-active');
          bag.setAttribute('aria-hidden', 'false');
          moveBag(clientX, clientY, true);

          if (!gsapApi || prefersReducedMotion()) {
            bag.style.opacity = '1';
            bag.style.visibility = 'visible';
            return;
          }

          gsapApi.to(bag, {
            autoAlpha: 1,
            scale: 1,
            duration: 0.22,
            ease: 'power2.out',
            overwrite: 'auto',
          });
        }

        function hideBag(delay) {
          var wait = typeof delay === 'number' ? delay : 0;
          if (hideTimer) clearTimeout(hideTimer);
          hideTimer = setTimeout(function () {
            active = false;
            root.classList.remove('is-bag-cursor');
            bag.classList.remove('is-active');
            bag.setAttribute('aria-hidden', 'true');

            if (!gsapApi || prefersReducedMotion()) {
              bag.style.opacity = '0';
              bag.style.visibility = 'hidden';
              return;
            }

            gsapApi.to(bag, {
              autoAlpha: 0,
              scale: 0.92,
              duration: 0.18,
              ease: 'power1.in',
              overwrite: 'auto',
            });
          }, wait);
        }

        function onMove(event) {
          if (!active) return;
          moveBag(event.clientX, event.clientY, false);
        }

        buttons.forEach(function (button) {
          button.addEventListener('pointerenter', function (event) {
            if (button.disabled) return;
            showBag(event.clientX, event.clientY);
          });
          button.addEventListener('pointermove', onMove);
          button.addEventListener('pointerleave', function () {
            hideBag(0);
          });
          button.addEventListener('blur', function () {
            hideBag(0);
          });
        });
      });
    }

    function initSizeChart(root) {
      var dialog = root.querySelector('[data-size-chart-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      root.querySelectorAll('[data-size-chart-open]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          dialog.showModal();
        });
      });

      root.querySelectorAll('[data-size-chart-close]').forEach(function (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dialog.close();
        });
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }

    function syncChromeHeights() {
      var header = document.querySelector('[data-header]');
      var rootStyles = document.documentElement.style;

      // Never write --header-height: 0 — header__inner uses the same token for
      // min-height. Transparent pages already omit header from product calc via CSS.
      if (header) {
        rootStyles.removeProperty('--header-height');
        var bar = header.querySelector('.header__bar') || header;
        var headerHeight = bar.getBoundingClientRect().height;
        if (headerHeight > 0) {
          rootStyles.setProperty('--header-height', headerHeight + 'px');
        }
      }
    }

    function armSilentVideo(video) {
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.controls = false;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');

      if (prefersReducedMotion()) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function initProduct(root) {
      if (!root || root.dataset.productInit === 'true') return;
      root.dataset.productInit = 'true';
      syncChromeHeights();
      var sliderApi = initSlider(root);
      initForm(root, sliderApi);
      initBagCursor(root);
      initSizeChart(root);
      root.querySelectorAll('video').forEach(armSilentVideo);
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-product]').forEach(initProduct);
    }

    initAll(document);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncChromeHeights, 100);
    });

    document.addEventListener('shopify:section:load', function (event) {
      var product = event.target.querySelector('[data-product]');
      if (product) initProduct(product);
    });

    document.addEventListener('giemma:page:leave', function () {
      document.querySelectorAll('body > [data-bag-illustration]').forEach(function (node) {
        node.remove();
      });
    });

    document.addEventListener('giemma:page:enter', function (event) {
      var container = event.detail && event.detail.container;
      initAll(container);
      // Only remeasure chrome when this page actually has a product section.
      if (container && container.querySelector('[data-product]')) {
        syncChromeHeights();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
